import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from './theme/muiTheme';
import { Router } from './Router';
import { SnackbarProvider } from 'notistack';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        autoHideDuration={2000}
        maxSnack={3}
      >
        <Router />
      </SnackbarProvider>
    </ThemeProvider>
  );
}
